/**
 * VAT selection bar constants.
 * Configuration for the VAT selection UI component.
 *
 * @module constants/vat-selection
 */

/** Locales where the VAT selection bar is enabled */
export const vatBarEnabledLocales = ['fr-FR']

/** VAT bar content data (French locale) */
export const vatBarData = {
  title: 'Nos prix sont affichés en HT (TVA de 20 % non incluse). Vous êtes un particulier ?',
  mobilePromptText: 'Vous pouvez modifier cette option dans le menu.',
  vatIncText: 'Oui, passer en TTC',
  vatExcText: 'Non, rester en HT',
}
export const excludedPageSectionsForVatBar = ['Gallery', 'Cart', 'undefined']
